import * as React from 'react';
import { bindActionCreators } from 'redux';
import { useAppDispatch } from './useAppDispatch';

import * as actions from '../slices';
import * as thunks from '../thunks';

/**
 * Набор местных экшнов, привязанных к диспатчу
 * */
export const useActions = () => {
  const dispatch = useAppDispatch();

  return React.useMemo(
    () =>
      bindActionCreators(
        {
          ...actions,
          ...thunks,
        },
        dispatch,
      ),
    [dispatch],
  );
};
